import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from 'next-intl';

import StyledContentBlocks from './contentBlocks.style';

import Container from '../../layout/container/container';
import ShareBox from '../../molecules/share-box/shareBox';

import getEmbed from '../../utility/getEmbed';

const renderAllEmbeds = (embeds, noShareLinks, locale, hasCuratedExhibitionTeasers) => {
  // We need to know what the previous component was, to add special styling
  let prevComponent;
  let nextComponent;

  return (
    embeds &&
    embeds.map((block, index) => {
      const prevBlock = embeds[index - 1];
      const nextBlock = embeds[index + 1];
      let classname = block.type;

      if (block.type === 'quote' && block.data.wide) {
        classname = `${block.type}--wide`;
      } else if (block.type === 'download' && block.data.vertical) {
        classname = `${block.type}--vertical`;
      } else if (block.type === 'download' && block.data.borderless) {
        classname = `${block.type}--borderless`;
      }

      if (nextBlock === undefined) {
        nextComponent = null;
      } else if (nextBlock.type === 'quote' && nextBlock.data.wide) {
        nextComponent = `${nextBlock.type}--wide`;
      } else if (nextBlock.type === 'download' && nextBlock.data.vertical) {
        nextComponent = `${nextBlock.type}--vertical`;
      } else {
        nextComponent = nextBlock.type;
      }

      if (prevBlock === undefined) {
        prevComponent = null;
      } else if (prevBlock.type === 'quote' && prevBlock.data.wide) {
        prevComponent = `${prevBlock.type}--wide`;
      } else if (prevBlock.type === 'download' && prevBlock.data.vertical) {
        prevComponent = `${prevBlock.type}--vertical`;
      } else if (prevBlock.type === 'audio' && prevBlock.data.wide) {
        prevComponent = `${prevBlock.type}--wide`;
      } else {
        prevComponent = prevBlock.type;
      }

      return hasCuratedExhibitionTeasers && block.type === 'loginMask' ? null : (
        <Container
          key={`contentBlock-${classname}-${index}`}
          className={`contentBlocks__container ${classname}-container`}
          large={
            block.type === 'fullwidthImage' ||
            block.type === 'video' ||
            block.type === 'map' ||
            block.type === 'vrImage' ||
            block.type === 'pdfviewer' ||
            block.type === 'teaserContainer' ||
            block.type === 'gameTeaser' ||
            (block.type === 'iframe' && block?.data?.wide)
          }
          fill={
            block.type === 'gallery' ||
            block.type === 'embeddedVideo' ||
            block.type === 'steps' ||
            block.type === 'eventGallery' ||
            block.type === 'stakeholderLogoSlider' ||
            block.type === 'quoteSlider' ||
            block.type === 'splineScene'
          }
          data-prev-component={prevComponent}
          data-next-component={nextComponent}
        >
          {index === 0 && !noShareLinks && <ShareBox />}
          {getEmbed(block, locale)[block.type]}
        </Container>
      );
    })
  );
};

const ContentBlocks = ({ embeds, noShareLinks = false, hasCuratedExhibitionTeasers = false }) => {
  const locale = useLocale();
  return embeds && embeds.length > 0 ? (
    <StyledContentBlocks>
      {renderAllEmbeds(embeds, noShareLinks, locale, hasCuratedExhibitionTeasers)}
    </StyledContentBlocks>
  ) : null;
};

ContentBlocks.propTypes = {
  embeds: PropTypes.arrayOf(PropTypes.shape()),
  noShareLinks: PropTypes.bool,
  hasCuratedExhibitionTeasers: PropTypes.bool
};

export default ContentBlocks;
